import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Chart } from '../../shared/charts/charts.class';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
import { Observable, Subscription, combineLatest, BehaviorSubject } from 'rxjs';
import {
  selectPerformanceDate,
  selectPerformanceYears,
  selectPerformanceMonths,
  selectPerformanceYearFilter,
  selectPerformanceMonthFilter,
  selectPerformanceTypeFilter,
  selectPerformanceOptionFilter,
  selectPerformanceFundsList,
  selectPerformanceFundFilter,
  selectPerformanceSelectedFund,
  selectPerformanceFunds,
  selectPerformanceFilter,
  selectPerformanceLoading,
  selectPerformanceDatesMin,
  selectPerformanceDatesMax,
  selectPerformanceTotal
} from './performance.selectors';
import {
  selectMainFilterSelectedAccount,
  selectMainFilter,
  selectStaticData,
  selectMainPageNotes, selectMainFilterSelectedClient, selectCountrySelected
} from '../../shared/layout/main.selectors';
import {
  PerformanceFileDownloadAction,
  LoadPerformanceDatesAction,
  SetPerformanceYearFilterAction,
  SetPerformanceMonthFilterAction,
  LoadPerformanceDataAction,
  SetPerformanceTypeFilterAction,
  SetPerformanceOptionFilterAction,
  SetPerformanceFundFilterAction,
  ResetPerformanceDataAction,
  ResetPerformanceFilterAction
} from './performance.actions';
import { map, filter, take, distinctUntilChanged } from 'rxjs/operators';
import { TableHeader, SortInfo, PageNotes, CommonConstants, ColumnDef } from '../../global/interfaces';
// import { AddErrorToastAction, RemoveToastsAction } from '../toaster/toaster.actions';
import { Month, formatDate, MONTHS } from '../../global/dates';
import * as moment from 'moment';
// import { PaginationInfo, MosConfigurationService } from 'merceros-ui-components';
import { getDataUri } from '../../global/getDataUri';
import {
  PERFORMANCE_KEYS,
  PerformanceTableRow,
  PerformanceFund,
  PERFORMANCE_KEY_LABELS,
  PerformanceManager,
  PerformanceDrildown,
  PerformanceFundData,
  PerformanceTypes,
  PerformanceOptions,
  Types, PERFORMANCE_COMMON_HEADERS,
} from './performance.models';
import { DATA_LABELS, DataLabels } from '../../global/data-labels';
import { DecimalService } from '../../global/pipes/decimal.pipe';
import { sortBy, isEqual, isEmpty, some } from 'lodash';
import { DrilldownOptions, PlotOptions, SeriesBarOptions, PlotLineOrBand } from 'highcharts';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { georgiaFontFamily, georgiaFontVfs } from '../../shared/pdfs/georgia-font';
import { WindowResizeService } from '../../global/window-resize.service';
import { selectAuthUser } from '../auth/auth.selectors';
import { breakSentenceByWhitespaces, capitalizeFirstChar, convertDateForIE, getMinMaxValues, getTickPositions } from '../../shared/utils';
import { pdfFooter, pdfHeader, pdfStyle } from '../../shared/pdfs/templates';
import { User } from '../administration/user/user.models';
import { selectConsultants } from '../features.selectors';
import { LoadClientConsultantAction } from '../features.actions';
import { CONFIG } from '../../../config';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { Actions, FieldSize } from 'atlas-cdk';
import { ToastService } from '../../shared/toaster_/toaster_.service';
import { Sortable, TableSortDirections } from 'atlas-table';
import { AlertService } from 'atlas-alert';
import { DropdownPlacement, DropdownTriggerType } from 'atlas-menu';



@Component({
  standalone: false,
  selector: 'dsp-performance',
  templateUrl: 'performance.container.html',
  styleUrls: ['performance.container.scss']
})
export class PerformanceContainerComponent implements OnInit, OnDestroy {
  dropdownTriggerTypeIconButton = DropdownTriggerType.IconButton;
  dropdownPlacementLeftStart = DropdownPlacement.LeftStart;
  @ViewChild('performanceChart')
  public performanceChart: ElementRef;

  sizeMedium = FieldSize.medium;
  sizeSmall = FieldSize.small;

  public headers: ColumnDef[] = [
    {
      name: 'Name',
      column: 'name',
      displayLabel: 'Name',
      fieldKey: 'name',
      sortable: true,
    }]
  public filterTypes: string[] = ['select', 'select', 'select', 'select'];
  public mobileFilterTypes: string[] = ['select', 'datepicker'];
  public optionFilterOptions = [
    { label: 'Total Returns', value: 'total' as PerformanceOptions },
    { label: 'Excess Returns', value: 'excess' as PerformanceOptions }
  ];

  public option: PerformanceOptions;

  public fund: string;

  public year: number;

  public month: number;
  public asAt: Date;

  public account: Object;
  public performanceTypes = Types;
  public dataLabels: DataLabels = DATA_LABELS;
  public csvDataSelector: string;

  public minDate$: Observable<Date | undefined>;
  public maxDate$: Observable<Date | undefined>;
  public loading$: Observable<boolean>;
  public type$: Observable<PerformanceTypes>;
  public option$: Observable<PerformanceOptions>;
  public years$: Observable<number[]>;
  public yearFilterOptions$: Observable<{ label: number; value: number }[]>;
  public months$: Observable<Month[]>;
  public monthFilterOptions$: Observable<{ label: string; value: number }[]>;
  public funds$: Observable<{ _id: string; name: string }[]>;
  public fundFilterOptions$: Observable<{ label: string; value: string }[]>;
  public date$: Observable<string>;
  public chart$: Observable<Chart>;
  public table$: Observable<any>;
  // public pagination$: Observable<PaginationInfo>;
  public drilldown$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public sort$: BehaviorSubject<SortInfo> = new BehaviorSubject<SortInfo>({ column: 'name', reverse: false });
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public filterTypes$: BehaviorSubject<string[]> = new BehaviorSubject(this.filterTypes);
  public totalAvailable$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public notes$: BehaviorSubject<PageNotes> = new BehaviorSubject<PageNotes>({} as PageNotes);
  public user$: Observable<User | undefined>;
  public highlightAllFunds = false;
  private readonly subscription: Subscription = new Subscription();
  public country = '';

  public constructor(
    private readonly store: Store<AppState>,
    private readonly decimal: DecimalService,
    // ,
    private readonly resize: WindowResizeService,
    private readonly _toasterService: ToastService,
    private readonly alertService: AlertService
  ) {
    this.headers = this.headers.concat(PERFORMANCE_COMMON_HEADERS);
    this.loading$ = this.selectLoading();
    this.type$ = this.selectType();
    this.option$ = this.selectOption();
    this.years$ = this.selectYears();
    this.yearFilterOptions$ = this.years$.pipe(
      map(years => years.map(year => ({
        label: year,
        value: year
      })))
    );
    this.months$ = this.selectMonths();
    this.monthFilterOptions$ = this.months$.pipe(
      map(months => months.map(month => ({
        label: month.name,
        value: month.value
      })))
    );
    this.funds$ = this.selectFunds();
    this.fundFilterOptions$ = combineLatest([
      this.funds$,
      this.totalAvailable$
    ]).pipe(
      map(([funds, totalAvailable]) => {
        const options = funds.map(fund => ({
          label: fund.name,
          value: fund._id
        }));

        return totalAvailable
          ? [{ label: 'Total Portfolio', value: 'total' }, ...options]
          : options;
      })
    );
    this.date$ = this.selectDate();
    this.chart$ = this.selectChart();
    this.table$ = this.selectTable();
    // this.pagination$ = this.selectPagination();
    this.minDate$ = this.selectMinDate();
    this.maxDate$ = this.selectMaxDate();
    this.user$ = this.store.pipe(select(selectAuthUser));
  }

  public ngOnInit(): void {
    //this.store.dispatch(new RemoveToastsAction());
    this.alertService.destroyAlertSnackbar();
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.subscribeLoadPerformanceDates());
    this.subscription.add(this.subscribeLoadPerformanceData());
    this.subscription.add(this.subscribeOptionFilter());
    this.subscription.add(this.subscribeInitialFundFilter());
    this.subscription.add(this.subscribeFundFilter());
    this.subscription.add(this.subscribeInitialYearFilter());
    this.subscription.add(this.subscribeYearFilter());
    this.subscription.add(this.subscribeInitialMonthFilter());
    this.subscription.add(this.subscribeMonthFilter());
    this.subscription.add(this.subscribeAsAtFilter());
    this.subscription.add(this.subscribeResetData());
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeFilterTypes());
    this.subscription.add(this.subscribeTotalAvailable());
    this.subscription.add(this.subscribeNotes());
    this.subscription.add(this.subscribeConsultantLoad());
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new ResetPerformanceFilterAction());
    this.year = undefined;
    this.month = undefined;
    this.subscription.unsubscribe();
  }
  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.country = country;
    });
  }

  private subscribeConsultantLoad(): Subscription {
    return this.user$.subscribe(user => {
      if (user) {
        this.store.pipe(select(selectMainFilterSelectedClient)).subscribe(client => {
          if (!isNullOrUndefined(client)) {
            this.store.dispatch(new LoadClientConsultantAction(client._id));
          }
        });
      }
    });
  }

  public onSort(event: SortInfo): void {
    this.sort$.next(event);
  }

  public onChangeType(): void {
    this.store.dispatch(new SetPerformanceTypeFilterAction());
  }

  public onChangeOption(event: PerformanceOptions): void {
    if (event.length) {
      this.store.pipe(
        select(selectPerformanceOptionFilter),
        take(1)
      ).subscribe(option => {
        if (option && option !== event) {
          this.drilldown$.next('');
        }
      });

      this.store.dispatch(new SetPerformanceOptionFilterAction(event));
    }
  }


  public onChangeFund(event: string): void {
    if (event.length) {
      this.store.pipe(
        select(selectPerformanceFundFilter),
        take(1)
      ).subscribe(fund => {
        if (fund && fund !== event) {
          this.drilldown$.next('');
        }
      });

      this.store.dispatch(new SetPerformanceFundFilterAction(event));

    }
  }



  public onChangeYear(event: number): void {
    if (event !== null && event !== undefined) {
      this.store.pipe(
        select(selectPerformanceYearFilter),
        take(1)
      ).subscribe(year => {
        if (year && year !== event) {
          this.drilldown$.next('');
        }
      });

      this.store.dispatch(new SetPerformanceYearFilterAction(event));

      this.store.pipe(
        select(selectPerformanceMonths),
        take(1)
      ).subscribe(months => {
        this.store.dispatch(new SetPerformanceMonthFilterAction(months[months.length - 1].value));
      });
    }
  }


  public onChangeMonth(event: number): void {
    if (event !== null && event !== undefined) {

      this.store.pipe(
        select(selectPerformanceMonthFilter),
        take(1)
      ).subscribe(month => {
        if (Number.isInteger(month) && month !== event) {
          this.drilldown$.next('');
        }
      });

      this.store.dispatch(new SetPerformanceMonthFilterAction(event));

    }
  }

  public onChangeAsAt(event: Date | string): void {
    // combineLatest(
    //   this.store.pipe(select(selectPerformanceYearFilter)),
    //   this.store.pipe(select(selectPerformanceMonthFilter))
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectPerformanceYearFilter)),
      this.store.pipe(select(selectPerformanceMonthFilter))]
    ).pipe(
      take(1)
    ).subscribe(([year, month]) => {
      if (event !== null && event !== undefined) {
        const date = moment(event);

        if (!date.isValid()) {
          return;
        }

        const
          newMonth = date.month(),
          newYear = date.year();

        if (newMonth !== month) {
          this.store.dispatch(new SetPerformanceMonthFilterAction(newMonth));
        }

        if (newYear !== year) {
          this.store.dispatch(new SetPerformanceYearFilterAction(newYear));
        }
      }
    });
  }

  // public onExportCSV(): void {
  //   combineLatest(
  //     this.store.pipe(select(selectMainFilterSelectedAccount)),
  //     this.store.pipe(select(selectPerformanceFunds)),
  //     this.store.pipe(select(selectPerformanceTypeFilter)),
  //     this.store.pipe(select(selectPerformanceYearFilter)),
  //     this.store.pipe(select(selectPerformanceMonthFilter))
  //   ).pipe(
  public onExportCSV(): void {
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectPerformanceFunds)),
      this.store.pipe(select(selectPerformanceTypeFilter)),
      this.store.pipe(select(selectPerformanceYearFilter)),
      this.store.pipe(select(selectPerformanceMonthFilter))]
    ).pipe(
      map(([account, funds, type, year, month]) => ({
        account: !!account ? account._id : undefined,
        funds: funds.map(fund => fund._id).join(';'),
        year: moment.utc({ year }).format('YYYY'),
        month: moment.utc({ month }).format('MM'),
        type,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      this.optionSelector();
      if (!!payload.account && payload.funds.length > 0) {
        payload['option'] = this.csvDataSelector;
        this.store.dispatch(new PerformanceFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        //this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.", Actions.error);
      }
    });
  }

  public onExportPDF(): void {
    combineLatest([
      this.store.pipe(select(selectPerformanceTotal)),
      this.store.pipe(select(selectMainFilter)),
      this.store.pipe(select(selectPerformanceFunds)),
      this.store.pipe(select(selectPerformanceFilter)),
      this.drilldown$,
      this.type$,
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectAuthUser)),
      this.store.pipe(select(selectConsultants)),
      this.store.pipe(select(selectPerformanceMonthFilter)),
      this.store.pipe(select(selectPerformanceYearFilter))]
    ).pipe(
      map(([totalPortfolio, main, data, filter, drilldown, type, staticData, pageNotes, user, consultants, month, year]) =>
      ({
        totalPortfolio,
        client: main.client[0].name,
        data: sortBy(data, (fund: PerformanceFund) => fund.name),
        option: filter.option,
        filter: filter.fund,
        drilldown,
        type,
        staticData,
        account: main.account[0],
        pageNotes,
        user,
        consultants,
        country: this.country,
        month,
        year
      }
      )),
      take(1)
    ).subscribe(payload => {
      if (!!payload.account && payload.data.length > 0) {
        const data = this.generateTable(payload.totalPortfolio, payload.data, payload.option,
          payload.filter, payload.type, payload.drilldown, true),
          body = data.map(data => {
            const textCellCss = (data.name === 'Total Portfolio') ? 'totalPortfolioText' :
              (data.parent === 'total' ? 'totalPortfolioBenchmarkText' : 'textCell'),
              numberCellCss = (data.name === 'Total Portfolio') ? 'totalPortfolioNumber' :
                (data.parent === 'total' ? 'totalPortfolioBenchmarkNumber' : 'numberCell');
            return [
              {
                text: !data.parent ? { text: data.name || '-', bold: true } : data.name || '-',
                style: textCellCss
              },
              {
                text: data['1m'] ? this.decimal.transform(data['1m']) : '-', style: numberCellCss
              },
              {
                text: data['3m'] ? this.decimal.transform(data['3m']) : '-', style: numberCellCss
              },
              {
                text: data['CYTD'] ? this.decimal.transform(data['CYTD']) : '-', style: numberCellCss
              },
              {
                text: data['FYTD'] ? this.decimal.transform(data['FYTD']) : '-', style: numberCellCss
              },
              {
                text: data['1y'] ? this.decimal.transform(data['1y']) : '-', style: numberCellCss
              },
              {
                text: data['3y'] ? this.decimal.transform(data['3y']) : '-', style: numberCellCss
              },
              {
                text: data['5y'] ? this.decimal.transform(data['5y']) : '-', style: numberCellCss
              },
              {
                text: data['7y'] ? this.decimal.transform(data['7y']) : '-', style: numberCellCss
              },
              {
                text: data['10y'] ? this.decimal.transform(data['10y']) : '-', style: numberCellCss
              }
            ];
          }),

          mmcLogo = [],
          mercerLogo = [],
          icons = [],

          promises = [];
        promises.push(getDataUri('assets/images/mmc_logo.png', CommonConstants.pdfMmcLogoWidth, CommonConstants.pdfMmcLogoHeight)
          .then(data => mmcLogo.push(data)));
        promises.push(getDataUri('assets/images/mercer_brand_logo.png',
          CommonConstants.pdfMercerLogoWidth, CommonConstants.pdfMercerLogoHeight)
          .then(data => mercerLogo.push(data)));
        promises.push(getDataUri('assets/images/phone.png', 18, 18)
          .then(data => icons['phone'] = data));
        promises.push(getDataUri('assets/images/email.png', 18, 18)
          .then(data => icons['email'] = data));
        promises.push(getDataUri('assets/images/website.png', 18, 18)
          .then(data => icons['website'] = data));
        setTimeout(() => {
          Promise.all(promises).then(() => {
            const date = `${MONTHS[payload.month].name} ${payload.year}`.toUpperCase();

            const address = [];
            address.push(
              {
                text: !isNullOrUndefined(payload.staticData.entityName) ?
                  `${payload.staticData.entityName}` : '', style: 'clientTitle', pageBreak: 'before'
              },
              {
                text: !isNullOrUndefined(payload.staticData.address) ?
                  `${payload.staticData.address}` : '', style: 'clientAddress'
              },
            );
            const docDefinition = {
              pageOrientation: 'landscape',
              content: [
                { text: 'Performance Report', style: 'title' },
                { text: date, style: 'subtitle' },
                { text: `${payload.client} - ${payload.account.name} - ${payload.account.number}`, style: 'subsubtitle' },
                { text: 'Date Generated: ' + moment().format(CommonConstants.displayDateFormatInAU), style: 'subtitleDate' },
                {
                  text:
                    `Performance Details (${capitalizeFirstChar(payload.option)} Returns - ${capitalizeFirstChar(payload.type)} of Fees)`,
                  style: 'chartTitleNew'
                },
                { text: `as at end of ${moment.utc(convertDateForIE(date)).format('MMM YYYY')}`, style: 'subChartTitleNew' },
                {
                  table: {
                    headerRows: 1,
                    dontBreakRows: true,
                    widths: ['20%', '8%', '8%', '8%', '8%', '8%', '8%', '8%', '8%', '8%'],
                    body: [
                      [
                        { text: 'NAME', style: 'tableHeader' },
                        { text: '1MTH (%)', style: 'tableHeader' },
                        { text: '3MTH (%)', style: 'tableHeader' },
                        { text: 'CYTD (%)', style: 'tableHeader' },
                        { text: 'FYTD (%)', style: 'tableHeader' },
                        { text: '1YR (%)', style: 'tableHeader' },
                        { text: '3YR (%\xa0P.A.)', style: 'tableHeader' },
                        { text: '5YR (%\xa0P.A.)', style: 'tableHeader' },
                        { text: '7YR (%\xa0P.A.)', style: 'tableHeader' },
                        { text: '10YR (%\xa0P.A.)', style: 'tableHeader' }
                      ],
                      ...body
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },
                  }
                },
                { text: CommonConstants.notes, style: 'notesTitle', pageBreak: 'before' },
                { text: `${payload.pageNotes.performance.table.replace(/<br\/>/g, '\n')}`, style: 'notesData', pageBreak: 'after' },
                ...payload.consultants.map(consultant =>
                ([
                  { text: `${consultant.firstName} ${consultant.lastName}` || '', style: 'consultantName' },
                  {
                    columns: [
                      // { image: icons['phone'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                      { text: `${consultant.phone}` || '', style: 'consultantPhone' }
                    ]
                  },
                  {
                    columns: [
                      // { image: icons['email'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                      { text: `${consultant.username}` || '', style: 'consultantMail' },
                    ]
                  },
                ]
                )),
                { text: 'Mercer Multi Manager Fund Contact Details', style: 'fundContactTitle' },
                {
                  columns: [
                    // { image: icons['phone'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                    { text: `${payload.staticData.phone || ''}`, style: 'fundContactPhone' }
                  ]
                },
                {
                  columns: [
                    // { image: icons['email'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                    { text: `${payload.staticData.email || ''}`, style: 'fundContactEmail' }
                  ]
                },
                {
                  columns: [
                    // { image: icons['website'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                    { text: `${payload.staticData.website || ''}`, style: 'fundContactWebsite' }
                  ]
                },
                { text: CommonConstants.importantNotices, style: 'noticeTitle', pageBreak: 'before' },
                { text: payload.staticData.importantNotices, style: 'noticeData' },
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, 'Performance Report', currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };

            pdfMake.vfs = {
              ...(pdfFonts.pdfMake as any).vfs,
              ...georgiaFontVfs
            };
            pdfMake.fonts = {
              ...georgiaFontFamily,
              Roboto: {
                normal: 'Roboto-Regular.ttf',
                bold: 'Roboto-Medium.ttf',
                italics: 'Roboto-Italic.ttf',
                bolditalics: 'Roboto-MediumItalic.ttf'
              }
            };
            pdfMake.createPdf(docDefinition).download('PerformanceExport.pdf');
          });
        }, 1000);
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        //this.store.dispatch(new AddErrorToastAction(`There is no data in specified ${this.year} and ${this.month}.`));
        return this._toasterService.launchAlertError(`There is no data in specified ${this.year} and ${this.month}.`, Actions.error);

      }
    });
  }

  private subscribeLoadPerformanceDates(): Subscription {
    return this.store.pipe(
      select(selectMainFilterSelectedAccount),
      distinctUntilChanged(isEqual)
    ).subscribe(account => {
      if (!!account) {
        this.store.dispatch(new ResetPerformanceDataAction());
        this.store.dispatch(new LoadPerformanceDatesAction({ account: account._id }));
        this.account = account._id;
        this.drilldown$.next('');
      }
    });
  }

  // private subscribeLoadPerformanceData(): Subscription {
  //   // return combineLatest(
  //   //   this.store.pipe(select(selectPerformanceMonthFilter)),
  //   //   this.store.pipe(select(selectPerformanceYearFilter))
  //   // ).pipe(
  //   return combineLatest([
  //     this.store.pipe(select(selectPerformanceMonthFilter)),
  //     this.store.pipe(select(selectPerformanceYearFilter))]
  //   ).pipe(
  //     distinctUntilChanged(isEqual)
  //   ).subscribe(([month, year]) => {
  //     if (!!this.account && month !== undefined && year !== undefined) {
  //       this.store.dispatch(new LoadPerformanceDataAction({
  //         account: this.account,
  //         month: moment.utc({ month }).format('MM'),
  //         year: moment.utc({ year }).format('YYYY'),
  //         option: this.option[0]
  //       }));
  //     }
  //   });
  // }

  private subscribeLoadPerformanceData(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectPerformanceMonthFilter)),
      this.store.pipe(select(selectPerformanceYearFilter)),
      this.store.pipe(select(selectPerformanceOptionFilter))  // add option here
    ]).pipe(
      distinctUntilChanged(isEqual)
    ).subscribe(([month, year, option]) => {
      if (!!this.account && month !== undefined && year !== undefined && option) {
        this.option = option;
        this.store.dispatch(new LoadPerformanceDataAction({
          account: this.account,
          month: moment.utc({ month }).format('MM'),
          year: moment.utc({ year }).format('YYYY'),
          option
        }));
      }
    });
  }

  private subscribeResetData(): Subscription {
    return this.store.pipe(
      select(selectMainFilterSelectedAccount),
      distinctUntilChanged(isEqual)
    ).subscribe(account => {
      if (!account) {
        this.store.dispatch(new ResetPerformanceDataAction());
      }
    });
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }

  private subscribeOptionFilter(): Subscription {
    return this.store.pipe(
      select(selectPerformanceOptionFilter),
      filter(option => !!option)
    ).subscribe(option => {
      this.option = option;

    });
  }

  /**
   * Sets fund filter value in store after new data is loaded
   */
  private subscribeInitialFundFilter(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectPerformanceFundsList)),
    //   this.store.pipe(select(sele[ctPerformanceTotal))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectPerformanceFundsList)),
      this.store.pipe(select(selectPerformanceTotal))]
    ).pipe(
      filter(([funds]) => !!funds.length),
      map(([funds, total]) => {
        if (total !== undefined && !some(total, isEmpty)) {
          return 'total';
        }

        return funds[0]._id;
      }),
    ).subscribe(fund => {
      this.store.dispatch(new SetPerformanceFundFilterAction(fund));
    });
  }

  private subscribeFundFilter(): Subscription {
    return this.store.pipe(
      select(selectPerformanceFundFilter)
    ).subscribe(fund => {
      this.fund = !!fund ? fund : undefined;
    });
  }

  private subscribeInitialYearFilter(): Subscription {
    //   return combineLatest(
    //     this.store.pipe(select(selectPerformanceYears)),
    //     this.store.pipe(select(selectPerformanceYearFilter))
    //   ).pipe(
    return combineLatest([
      this.store.pipe(select(selectPerformanceYears)),
      this.store.pipe(select(selectPerformanceYearFilter))]
    ).pipe(
      filter(([years]) => !!years.length),
      map(([years, year]) => year !== undefined ? year : years[0])
    ).subscribe(year => {
      this.store.dispatch(new SetPerformanceYearFilterAction(year));
    });
  }

  private subscribeYearFilter(): Subscription {
    return this.store.pipe(
      select(selectPerformanceYearFilter)
    ).subscribe(year => {
      this.year = year !== undefined ? year : undefined;
    });
  }

  private subscribeInitialMonthFilter(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectPerformanceMonths)),
    //   this.store.pipe(select(selectPerformanceMonthFilter))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectPerformanceMonths)),
      this.store.pipe(select(selectPerformanceMonthFilter))]
    ).pipe(
      filter(([months, month]) => !!months.length && month === undefined),
      map(([months, month]) => month !== undefined ? month : months[months.length - 1].value)
    ).subscribe(month => {
      this.store.dispatch(new SetPerformanceMonthFilterAction(month));
    });
  }



  private subscribeMonthFilter(): Subscription {
    return this.store.pipe(
      select(selectPerformanceMonthFilter)
    ).subscribe(month => {
      this.month = month !== undefined ? month : undefined;
    });
  }

  private subscribeAsAtFilter(): Subscription {
    return this.store.pipe(
      select(selectPerformanceDatesMax),
      filter(max => max !== undefined)
    ).subscribe(max => {
      this.asAt = moment(max.format('YYYY-MM-DD'), 'YYYY-MM-DD').toDate();
    });
  }

  private subscribeFilterTypes(): Subscription {
    return this.isMobile$.pipe(
      map(isMobile => !isMobile ? this.filterTypes : this.mobileFilterTypes)
    ).subscribe(this.filterTypes$);
  }

  private subscribeTotalAvailable(): Subscription {
    return this.store.pipe(
      select(selectPerformanceTotal),
      map(total => total !== undefined && !some(total, isEmpty))
    ).subscribe(this.totalAvailable$);
  }

  private subscribeNotes(): Subscription {
    return this.store.pipe(
      select(selectMainPageNotes)
    ).subscribe(this.notes$);
  }

  private selectLoading(): Observable<boolean> {
    return this.store.pipe(
      select(selectPerformanceLoading)
    );
  }

  private selectType(): Observable<PerformanceTypes> {
    return this.store.pipe(
      select(selectPerformanceTypeFilter)
    );
  }

  private selectOption(): Observable<PerformanceOptions> {
    return this.store.pipe(
      select(selectPerformanceOptionFilter)
    );
  }

  private selectYears(): Observable<number[]> {
    return this.store.pipe(
      select(selectPerformanceYears)
    );
  }

  private selectMonths(): Observable<Month[]> {
    return this.store.pipe(
      select(selectPerformanceMonths)
    );
  }

  private selectFunds(): Observable<{ _id: string; name: string }[]> {
    return this.store.pipe(
      select(selectPerformanceFundsList)
    );
  }

  private selectDate(): Observable<string> {
    return this.store.pipe(
      select(selectPerformanceDate),
      map(date => formatDate(date, 'MMM YYYY'))
    );
  }

  // private selectPagination(): Observable<PaginationInfo> {
  //   return this.store.pipe(
  //     select(selectPerformanceFundsList),
  //     map(funds => ({
  //       offset: 0,
  //       limit: funds.length,
  //       totalCount: funds.length
  //     }))
  //   );
  // }

  private selectMinDate(): Observable<Date | undefined> {
    return this.store.pipe(
      select(selectPerformanceDatesMin),
      map(min => min ? moment(min.format('YYYY-MM-DD'), 'YYYY-MM-DD').toDate() : undefined)
    );
  }

  private selectMaxDate(): Observable<Date | undefined> {
    return this.store.pipe(
      select(selectPerformanceDatesMax),
      map(max => max ? moment(max.format('YYYY-MM-DD'), 'YYYY-MM-DD').toDate() : undefined)
    );
  }

  private selectChart(): Observable<Chart> {
    return combineLatest([
      this.store.pipe(select(selectPerformanceSelectedFund)),
      this.store.pipe(select(selectPerformanceTypeFilter)),
      this.store.pipe(select(selectPerformanceOptionFilter))]
    ).pipe(
      filter(([fund]) => !!fund),
      distinctUntilChanged(isEqual),
      map(([fund, type, option]) => {
        const series = [],
          drilldowns: PerformanceDrildown[] = [];

        if (option === 'total') {
          const totalSerie: PerformanceDrildown = {
            name: fund.name,
            color: '#F48132',
            data: [],
            range: {
              min: 0,
              max: 0
            }
          },

            benchSerie: PerformanceDrildown = {
              name: 'Benchmark', // fund.benchmarkName,
              color: '#BBEEF9',
              data: [],
              range: {
                min: 0,
                max: 0
              }
            };

          PERFORMANCE_KEYS.forEach(key => {
            const fundData = fund[key] as PerformanceFundData;

            if (fund.managers.length) {
              totalSerie.data.push({
                name: PERFORMANCE_KEY_LABELS[key],
                y: parseFloat(fundData[type]),
                drilldown: key
              });

              benchSerie.data.push({
                name: PERFORMANCE_KEY_LABELS[key],
                y: parseFloat(fundData.benchmark),
                drilldown: key + 'bench'
              });

              const managerDrilldown: PerformanceDrildown = {
                name: key,
                id: key,
                data: [],
                range: {
                  min: 0,
                  max: 0
                }
              },

                managerBench: PerformanceDrildown = {
                  name: key + ' Benchmark',
                  id: key + 'bench',
                  data: [],
                  range: {
                    min: 0,
                    max: 0
                  }
                };

              fund.managers.forEach(manager => {
                const managerData = manager[key] as PerformanceFundData;
                if (fund.name === 'Total Portfolio') {
                  const yValue = type === 'gross' && managerData.gross !== 'N/A' ?
                    managerData.gross : (type === 'net' && managerData.net !== 'N/A' ?
                      managerData.net : '');
                  managerDrilldown.data.push({
                    name: manager.name,
                    tooltip: manager.name,
                    y: parseFloat(yValue)
                  });
                } else {
                  if (managerData.grossExcess !== 'N/A') {
                    managerDrilldown.data.push({
                      name: manager.name,
                      tooltip: manager.name,
                      y: parseFloat(managerData.gross)
                    });
                  }
                }
                if (managerData.benchmark !== 'N/A') {
                  managerBench.data.push({
                    name: manager.name,
                    tooltip: 'Benchmark', // manager.benchmarkName,
                    y: parseFloat(managerData.benchmark)
                  });
                }
              });

              const maxMin = getMinMaxValues(managerDrilldown.data, managerBench.data);
              managerDrilldown.range.max = maxMin.max;
              managerDrilldown.range.min = maxMin.min;
              managerBench.range.max = maxMin.max;
              managerBench.range.min = maxMin.min;
              drilldowns.push(managerDrilldown);
              drilldowns.push(managerBench);
            } else {
              totalSerie.data.push([
                PERFORMANCE_KEY_LABELS[key],
                parseFloat(fundData[type])
              ]);

              benchSerie.data.push([
                PERFORMANCE_KEY_LABELS[key],
                parseFloat(fundData.benchmark)
              ]);
            }
          });
          const maxMin = (!fund.managers.length)
            ? getMinMaxValues(totalSerie.data, benchSerie.data, 1)
            : getMinMaxValues(totalSerie.data, benchSerie.data, 'y');

          totalSerie.range.max = maxMin.max;
          totalSerie.range.min = maxMin.min;
          series.push(totalSerie);
          series.push(benchSerie);
        }

        if (option === 'excess') {
          const excessSerie: PerformanceDrildown = {
            name: fund.name,
            color: '#F48132',
            data: [],
            range: {
              min: 0,
              max: 0
            }
          };

          PERFORMANCE_KEYS.forEach(key => {
            const fundKey = key as keyof PerformanceFund,
              managerKey = key as keyof PerformanceManager,
              fundData = fund[fundKey] as PerformanceFundData,
              currentType = `${type as keyof PerformanceFundData}Excess`;

            if (fund.managers.length) {
              excessSerie.data.push({
                name: PERFORMANCE_KEY_LABELS[key],
                y: parseFloat(fundData[currentType]),
                drilldown: key
              });

              const excessDrilldown: PerformanceDrildown = {
                name: PERFORMANCE_KEY_LABELS[key],
                id: key,
                data: [],
                range: {
                  min: 0,
                  max: 0
                }
              };

              fund.managers.forEach(manager => {
                const managerData = manager[managerKey] as PerformanceFundData;

                if (fund.name === 'Total Portfolio') {
                  const yValue = type === 'gross' && managerData.grossExcess !== 'N/A' ?
                    managerData.grossExcess : (type === 'net' && managerData.netExcess !== 'N/A' ?
                      managerData.netExcess : '');
                  excessDrilldown.data.push([
                    manager.name,
                    parseFloat(yValue)
                  ]);
                } else {
                  if (managerData.grossExcess !== 'N/A') {
                    excessDrilldown.data.push([
                      manager.name,
                      parseFloat(managerData.grossExcess)
                    ]);
                  }
                }
              });

              const maxMin = getMinMaxValues(excessDrilldown.data, [], '1');
              excessDrilldown.range.max = maxMin.max;
              excessDrilldown.range.min = maxMin.min;
              drilldowns.push(excessDrilldown);
            } else {
              excessSerie.data.push([
                PERFORMANCE_KEY_LABELS[key],
                parseFloat(fundData[currentType])
              ]);
            }
          });

          const maxMin = getMinMaxValues(excessSerie.data, []);
          excessSerie.range.max = maxMin.max;
          excessSerie.range.min = maxMin.min;
          series.push(excessSerie);
        }

        const drilldown = this.drilldown$;

        return new Chart({
          lang: {
            drillUpText: '◁ Back'
          },
          chart: {
            type: 'column',
            style: {
              fontFamily: CommonConstants.semanticFontFamilyPlain,
            },
            events: {
              drilldown(event): void {
                setTimeout(() => {

                  const options = event.seriesOptions as SeriesBarOptions,
                    max = options.data.length - 1 >= 6;

                  drilldown.next(options.id || '');

                  this.update({
                    xAxis: {
                      max: max ? 6 : options.data.length - 1
                    },
                    yAxis: {
                      tickPositioner: function () {
                        // @ts-ignore
                        const max = options.range.max,
                          // @ts-ignore
                          min = options.range.min;
                        return getTickPositions(max, min);
                      },
                    }
                  });
                });
              },
              drillup(event): void {
                const options = event.seriesOptions as SeriesBarOptions;
                setTimeout(() => {
                  drilldown.next('');
                  this.update({
                    xAxis: {
                      max: 6,
                    },
                    yAxis: {
                      tickPositioner: function () {
                        // @ts-ignore
                        const max = options.range.max,
                          // @ts-ignore
                          min = options.range.min;
                        return getTickPositions(max, min);
                      },
                    }
                  });
                });
              }
            }
          },
          credits: {
            enabled: false
          },
          title: {
            style: {
              display: 'none'
            }
          },
          exporting: {
            enabled: false
          },
          plotOptions: {

            column: {
              cropThreshold: 250,
              dataLabels: {
                enabled: true,
                formatter() {
                  // @ts-ignore
                  return (Number.isInteger(this.y) ? this.y.toFixed(1) : this.y);
                }
              }
            },
            series: {
              pointWidth: 30,
              dataLabels: {
                enabled: true,
                crop: false,
                style: {
                  color: 'contrast',
                  fontSize: CommonConstants.chartFontSizeMedium,
                  fontWeight: CommonConstants.chartFontWeightBold,
                  textOutline: '1px contrast',
                }
              }
            }
          } as PlotOptions,
          tooltip: {
            enabled: true,
            style: {
              fontFamily: CommonConstants.semanticFontFamilyPlain
            },
            formatter(): string {
              const { tooltip, name } = this.point['tooltip'] !== undefined
                ? { tooltip: this.series.name, name: this.point['tooltip'] }
                : { tooltip: this.point.name, name: this.series.name };

              return `
                <span style="display: block; font-size: 10px">${tooltip}</span><br>
                <span style="color: ${this.color}">●</span>
                <span>${name}:</span>
                <span style="font-weight: ${CommonConstants.chartFontWeightBold}">${this.y}</span>
              `;
            }
          },
          legend: {
            enabled: true,
            itemStyle: {
              fontFamily: CommonConstants.semanticFontFamilyPlain
            }
          },
          yAxis: {
            tickPositioner: function () {
              const max = series[0].range.max,
                min = series[0].range.min;
              return getTickPositions(max, min);
            },
            plotLines: [{ color: '#003399', width: 1.2, value: 0, }],
            title: {
              text: 'Returns %'
            }
          },
          xAxis: {
            type: 'category',
            gridLineWidth: 1,
            labels: {
              rotation: 0,
              style: {
                textOverflow: 'none',
                min: 0,
                lineWidth: 4,
                fontFamily: CommonConstants.semanticFontFamilyPlain,
              },
              formatter() {
                return typeof this.value !== 'number' ? this.value : '';
              }
            },
            max: 6,
            endOnTick: true,
            scrollbar: {
              enabled: true,
              showFull: false,
              margin: 25
            }
          },
          series,
          drilldown: {
            activeAxisLabelStyle: {
              cursor: 'pointer',
              color: '#003399',
              fontWeight: CommonConstants.chartFontWeightBold,
              textDecoration: 'none',
            },
            activeDataLabelStyle: {
              cursor: 'pointer',
              color: '#003399',
              fontWeight: CommonConstants.chartFontWeightBold,
              textDecoration: 'none',
            },
            allowPointDrilldown: false,
            series: drilldowns
          } as DrilldownOptions,
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 1200,
                },
                chartOptions: {
                  xAxis: {
                    labels: {
                      formatter() {
                        return breakSentenceByWhitespaces(this.value.toString(), 2);
                      },
                    },
                  },
                },
              },
              {
                condition: {
                  minWidth: 1200,
                },
                chartOptions: {
                  xAxis: {
                    labels: {
                      formatter() {
                        return breakSentenceByWhitespaces(this.value.toString());
                      },
                    },
                  },
                },
              },
            ],
          },
        });
      })
    );
  }

  private selectTable(): Observable<PerformanceTableRow[]> {
    return combineLatest([
      this.store.pipe(select(selectPerformanceTotal)),
      this.store.pipe(select(selectPerformanceFunds)),
      this.store.pipe(select(selectPerformanceOptionFilter)),
      this.store.pipe(select(selectPerformanceTypeFilter)),
      this.store.pipe(select(selectPerformanceFundFilter)),
      this.drilldown$,
      this.sort$,
      this.store.pipe(select(selectPerformanceSelectedFund))]
    ).pipe(
      map(([totalPortfolio, funds, option, type, filter, drilldown, sort, selectedFund]) => {
        // @ts-ignore
        funds = sort.reverse
          // @ts-ignore
          ? this.sortData(funds, sort, type).reverse()
          // @ts-ignore
          : this.sortData(funds, sort, type);
        //funds = this.sortData(funds, sort, type);
        // @ts-ignore
        drilldown && !isNullOrUndefined(selectedFund) &&
          // @ts-ignore
          !isNullOrUndefined(selectedFund.name) && selectedFund.name === 'Total Portfolio' ?
          // @ts-ignore
          this.highlightAllFunds = true : this.highlightAllFunds = false;
        // @ts-ignore
        return this.generateTable(totalPortfolio, funds, option, filter, type, drilldown);
      }),
      distinctUntilChanged(isEqual)
    );
  }


  private sortData(funds: PerformanceFund[], sort: { field: string; direction: string }, type: string): PerformanceFund[] {
    const sorted = sortBy(funds, (fund: PerformanceFund) => {
      const column = sort.field as keyof PerformanceFund;
      const val = fund[column];
      if (val && typeof val === 'object' && type) {
        const currentType = type as keyof PerformanceFundData;
        return (val as PerformanceFundData)[currentType];
      }
      return val;
    });

    if (sort.direction === 'desc') {
      return sorted.reverse();
    }
    return sorted;
  }

  private generateTable(
    totalPortfolio,
    funds: PerformanceFund[],
    option: PerformanceOptions,
    filter: string | undefined,
    type: string,
    drilldown: string,
    isExport = false
  ): PerformanceTableRow[] {
    const rows: PerformanceTableRow[] = [];
    // if (environment.APP_ENV === 'development') {
    if (!isNullOrUndefined(totalPortfolio) && (totalPortfolio.isClientPerfDataAvailable === 'true')) {
      // TO DO : PDF table and UI table
      if (option === 'total') {
        const currentType = type as keyof PerformanceFundData;
        rows.push({
          _id: `total`,
          name: `Total Portfolio`,
          selected: filter === 'total',
          '1m': totalPortfolio['1m'][currentType],
          '3m': totalPortfolio['3m'][currentType],
          CYTD: totalPortfolio['CYTD'][currentType],
          FYTD: totalPortfolio['FYTD'][currentType],
          '1y': totalPortfolio['1y'][currentType],
          '3y': totalPortfolio['3y'][currentType],
          '5y': totalPortfolio['5y'][currentType],
          '7y': totalPortfolio['7y'][currentType],
          '10y': totalPortfolio['10y'][currentType],
        } as PerformanceTableRow);

        rows.push({
          parent: `total`,
          name: 'Benchmark',  // isExport && fund.benchmarkName !== undefined ? fund.benchmarkName :  'Benchmark',
          tooltip: 'Benchmark', // fund.benchmarkName !== undefined ? fund.benchmarkName : '',
          selected: filter === 'total',
          '1m': totalPortfolio['1m'].benchmark,
          '3m': totalPortfolio['3m'].benchmark,
          CYTD: totalPortfolio['CYTD'].benchmark,
          FYTD: totalPortfolio['FYTD'].benchmark,
          '1y': totalPortfolio['1y'].benchmark,
          '3y': totalPortfolio['3y'].benchmark,
          '5y': totalPortfolio['5y'].benchmark,
          '7y': totalPortfolio['7y'].benchmark,
          '10y': totalPortfolio['10y'].benchmark
        } as PerformanceTableRow);
      }

      if (option === 'excess') {
        const currentType = `${type as keyof PerformanceFundData}Excess`;

        rows.push({
          _id: `total`,
          name: `Total Portfolio`,
          selected: filter === 'total',
          '1m': totalPortfolio['1m'][currentType],
          '3m': totalPortfolio['3m'][currentType],
          CYTD: totalPortfolio['CYTD'][currentType],
          FYTD: totalPortfolio['FYTD'][currentType],
          '1y': totalPortfolio['1y'][currentType],
          '3y': totalPortfolio['3y'][currentType],
          '5y': totalPortfolio['5y'][currentType],
          '7y': totalPortfolio['7y'][currentType],
          '10y': totalPortfolio['10y'][currentType]
        });
      }
    }
    // }
    funds.forEach((fund: PerformanceFund) => {
      if (option === 'total') {
        const currentType = type as keyof PerformanceFundData;

        rows.push({
          _id: fund._id,
          name: fund.name,
          selected: filter === fund._id,
          '1m': fund['1m'][currentType],
          '3m': fund['3m'][currentType],
          CYTD: fund['CYTD'][currentType],
          FYTD: fund['FYTD'][currentType],
          '1y': fund['1y'][currentType],
          '3y': fund['3y'][currentType],
          '5y': fund['5y'][currentType],
          '7y': fund['7y'][currentType],
          '10y': fund['10y'][currentType],
        } as PerformanceTableRow);

        rows.push({
          parent: fund._id,
          name: 'Benchmark',  // isExport && fund.benchmarkName !== undefined ? fund.benchmarkName :  'Benchmark',
          tooltip: 'Benchmark', // fund.benchmarkName !== undefined ? fund.benchmarkName : '',
          selected: filter === fund._id,
          '1m': fund['1m'].benchmark,
          '3m': fund['3m'].benchmark,
          CYTD: fund['CYTD'].benchmark,
          FYTD: fund['FYTD'].benchmark,
          '1y': fund['1y'].benchmark,
          '3y': fund['3y'].benchmark,
          '5y': fund['5y'].benchmark,
          '7y': fund['7y'].benchmark,
          '10y': fund['10y'].benchmark
        } as PerformanceTableRow);
      }

      if (option === 'excess') {
        const currentType = `${type as keyof PerformanceFundData}Excess`;

        rows.push({
          _id: fund._id,
          name: fund.name,
          selected: filter === fund._id,
          '1m': fund['1m'][currentType],
          '3m': fund['3m'][currentType],
          CYTD: fund['CYTD'][currentType],
          FYTD: fund['FYTD'][currentType],
          '1y': fund['1y'][currentType],
          '3y': fund['3y'][currentType],
          '5y': fund['5y'][currentType],
          '7y': fund['7y'][currentType],
          '10y': fund['10y'][currentType]
        });
      }

      if (drilldown && filter !== 'total') {
        let currentType = 'gross';

        if (option === 'excess') {
          currentType = 'grossExcess';
        }
        fund.managers.forEach((manager: PerformanceManager) => {
          rows.push({
            parent: fund._id,
            name: manager.name,
            selected: filter === fund._id,
            '1m': manager['1m'][currentType],
            '3m': manager['3m'][currentType],
            CYTD: manager['CYTD'][currentType],
            FYTD: manager['FYTD'][currentType],
            '1y': manager['1y'][currentType],
            '3y': manager['3y'][currentType],
            '5y': manager['5y'][currentType],
            '7y': manager['7y'][currentType],
            '10y': manager['10y'][currentType]
          } as PerformanceTableRow);
        });
      }
    });

    return rows;
  }

  public optionSelector() {
    this.type$.subscribe(type => {
      if (type === 'gross') {
        if (this.option === 'total') {
          this.csvDataSelector = 'gross';
        } else {
          this.csvDataSelector = 'grossExcess';
        }
      } else {
        if (this.option === 'total') {
          this.csvDataSelector = 'net';
        } else {
          this.csvDataSelector = 'netExcess';
        }
      }
    });
  }
  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }

  getFundCount(rows: PerformanceTableRow[]): number {
    if (!rows || rows.length === 0) {
      return 0;
    }
    return rows.filter(row => !row.parent && row.name !== 'Total Portfolio').length;
  }
}
